import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const LocationPoint = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M10.4693 8.30448C10.9546 8.10346 11.4747 8 12 8C12.5253 8 13.0454 8.10346 13.5307 8.30448C14.016 8.5055 14.457 8.80014 14.8284 9.17157C15.1999 9.54301 15.4945 9.98396 15.6955 10.4693C15.8965 10.9546 16 11.4747 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C11.4747 16 10.9546 15.8965 10.4693 15.6955C9.98396 15.4945 9.54301 15.1999 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.54301 8.80014 9.98396 8.5055 10.4693 8.30448Z" stroke="#3B82F6" stroke-width="2"/>
  </SvgIcon>
);
